import * as THREE from 'https://cdn.jsdelivr.net/npm/three@0.183.0/build/three.module.js';

// Hero atmosphere: gold halo and drifting dust behind the product polaroid.
const canvas = document.getElementById('tub');
const stage = document.getElementById('stage');
const reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;

let renderer;
try {
  renderer = new THREE.WebGLRenderer({ canvas, antialias: true, alpha: true, powerPreference: 'high-performance' });
} catch (e) {
  document.documentElement.classList.add('no-webgl');
  canvas.style.display = 'none';
}
if (renderer) init();

function init() {
  renderer.setPixelRatio(Math.min(devicePixelRatio, 2));
  renderer.outputColorSpace = THREE.SRGBColorSpace;

  const scene = new THREE.Scene();
  const camera = new THREE.PerspectiveCamera(26, 1, 0.1, 100);
  camera.position.set(0.32, 0.2, 9.2);
  camera.lookAt(0.32, 0.15, 0);

  // halo + ticks
  const halo = new THREE.Mesh(new THREE.RingGeometry(1.86, 1.885, 128), new THREE.MeshBasicMaterial({ color: 0xc9a24a, transparent: true, opacity: .45 }));
  halo.position.set(0, .3, -1.6); scene.add(halo);
  const halo2 = new THREE.Mesh(new THREE.RingGeometry(2.14, 2.15, 128), new THREE.MeshBasicMaterial({ color: 0xc9a24a, transparent: true, opacity: .18 }));
  halo2.position.copy(halo.position); scene.add(halo2);
  const tickMat = new THREE.MeshBasicMaterial({ color: 0xc9a24a, transparent: true, opacity: .5 });
  [[0, 1], [1, 0], [0, -1], [-1, 0]].forEach(([x, y]) => {
    const t = new THREE.Mesh(new THREE.PlaneGeometry(x ? .22 : .03, y ? .22 : .03), tickMat);
    t.position.set(x * 1.87, halo.position.y + y * 1.87, halo.position.z); scene.add(t);
  });

  [halo, halo2].forEach(m => m.scale.setScalar(1.18));
  scene.children.filter(o => o.material === tickMat).forEach(o => { o.position.x *= 1.18; o.position.y = halo.position.y + (o.position.y - halo.position.y) * 1.18; });
  // dust motes (parallax with the pointer; the product stays still)
  const motes = new THREE.Group(); scene.add(motes);
  const N = 260, pos = new Float32Array(N * 3), spd = new Float32Array(N);
  for (let i = 0; i < N; i++) { pos[i * 3] = (Math.random() - .5) * 6; pos[i * 3 + 1] = (Math.random() - .5) * 5; pos[i * 3 + 2] = (Math.random() - .5) * 3 - .5; spd[i] = .002 + Math.random() * .006; }
  const pg = new THREE.BufferGeometry(); pg.setAttribute('position', new THREE.BufferAttribute(pos, 3));
  const dot = document.createElement('canvas'); dot.width = dot.height = 32;
  const dc = dot.getContext('2d'); const dg = dc.createRadialGradient(16, 16, 0, 16, 16, 16);
  dg.addColorStop(0, 'rgba(255,225,160,1)'); dg.addColorStop(1, 'rgba(255,225,160,0)'); dc.fillStyle = dg; dc.fillRect(0, 0, 32, 32);
  motes.add(new THREE.Points(pg, new THREE.PointsMaterial({ size: .06, map: new THREE.CanvasTexture(dot), transparent: true, opacity: .8, depthWrite: false, blending: THREE.AdditiveBlending })));

  function resize() {
    const r = stage.getBoundingClientRect();
    renderer.setSize(r.width, r.height, false);
    camera.aspect = r.width / r.height; camera.updateProjectionMatrix();
    const off = innerWidth > 900 ? .32 : 0; camera.position.x = off; camera.lookAt(off, .15, 0);
  }
  new ResizeObserver(resize).observe(stage); resize();

  let mx = 0, my = 0, px = 0, py = 0;
  addEventListener('pointermove', e => { mx = e.clientX / innerWidth - .5; my = e.clientY / innerHeight - .5; }, { passive: true });

  let visible = true;
  new IntersectionObserver(([en]) => { visible = en.isIntersecting; }).observe(stage);

  const clock = new THREE.Clock();
  (function loop() {
    requestAnimationFrame(loop);
    if (!visible) return;
    const t = clock.getElapsedTime(), now = performance.now();
    halo.rotation.z = t * .05;
    px += (mx - px) * .05; py += (my - py) * .05;
    motes.position.set(-px * .35, py * .2, 0);
    if (!reduce) {
      const a = pg.attributes.position.array;
      for (let i = 0; i < N; i++) { a[i * 3 + 1] += spd[i]; a[i * 3] += Math.sin(t + i) * .0008; if (a[i * 3 + 1] > 2.6) a[i * 3 + 1] = -2.4; }
      pg.attributes.position.needsUpdate = true;
    }
    renderer.render(scene, camera);
  })();
}
